<template>
  <div class="casino-header-nt2" :class="{ 'header-active' : toggle}">
    <div class="casino-header">
        <div class="active-provider">
            <div class="game">
              <h4 class="line-title">{{ currentProvider }}</h4>
            </div>
        </div>
        <div class="search-input">
          <input v-model="search" type="text" placeholder="Hızlıca Sağlayıcı Ara">
        </div>
        <button class="button primary" @click="toggle = !toggle" :class="{ active : toggle}">
          {{ toggle ? 'Kapat' : 'Sağlayıcılar'}}  
          <span>
            <svg x="0px" y="0px" viewBox="0 0 490 490" xml:space="preserve"><g><g><polygon points="490,157.332 244.996,407.369 0,157.332 76.493,82.631 244.996,254.598 413.507,82.631   "></polygon></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
          </span>
        </button>
    </div>
    <div  class="providers-t" :class="{ 'toggle-active' : toggle}">
      <Providers :providers="providers"/>
    </div>
  </div>
</template>

<script>
    import Providers from './Providers'
    import SelectBox from '../Common/SelectBox'
    export default{
      data(){
        return{
          toggle: false,
          search:null,
        }
      },
      computed:{
        providers(){
          if(this.search){
            return this.$store.getters['slot/getProviders'].filter(item => item.provider.toLowerCase().includes(this.search.toLowerCase()));
          }else{
            return this.$store.getters['slot/getProviders']
          }
        },
        currentProvider(){
          return this.$store.getters['slot/getCurrentProvider'];
        }
      },
      watch:{
        currentProvider(val){
          this.toggle = false;
        }
      },
      components:{
        Providers,
        SelectBox
      }
    }
</script>

<style lang="scss">
  .casino-header-nt2{
    position: relative;
    .search-input{
      position: absolute;
      right: 120px;
      input{
        padding: 10px;
        border-radius: 5px;
        font-size: 11px;
      }
    }
    &.header-active{
      .search-input{
        right: 90px;
      }
    }
  } 

  #app.mobile .app-casino-mobile .search-input{
    right: 0px !important;
    input{
      padding: 10px !important;
      font-size: 12px !important;
    }
  } 

</style>